import { Button, Modal, Select, message } from "antd"
import React, { useState } from "react"
import { db } from "../../../../firebase/config"
import { doc, updateDoc } from "firebase/firestore"

export default function ChangeMachine(props) {
  const [machine, setMachine] = useState("Cutter")
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { orderId, order } = props
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = () => {
    setIsModalOpen(false)
    handleChangeMachine()
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleChangeMachine = async () => {
    const ref = doc(db, "orders", orderId)

    try {
      await updateDoc(ref, {
        "selectedProduct.machine": machine,
        originalMachine: order.originalMachine ? "Cutter" : order.selectedProduct.machine,
      })
    } catch (error) {
      message.error("error happened")
      console.log(error)
    } finally {
      message.success("updated")
    }
  }

  //handlemachine change
  const handleMachineChange = (value) => {
    setMachine(value)
  }

  //return desc
  const returnDescription = () => {
    return (
      <div style={{ width: "250px", zIndex: 999 }}>
        <Select
          style={{ width: "100%", zIndex: 3 }}
          onChange={handleMachineChange}
          options={[
            {
              label: "Cutter",
              value: "Cutter",
            },
            {
              label: "Viva",
              value: "Viva",
            },
          ]}
        />
      </div>
    )
  }

  return (
    <>
      <Button block onClick={showModal} danger>
        Change Machine
      </Button>

      <Modal title="Change machine" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        {returnDescription()}
      </Modal>
    </>
  )
}
